import Fretboard from './components/Fretboard'
import { TourProvider } from '@reactour/tour'
import './App.css'

/**
 * The main component of the application.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.premium - Indicates whether the user has a premium account.
 * @param {Object} props.viewer - The viewer object.
 * @param {boolean} props.isAnon - Indicates whether the user is anonymous.
 * @returns {JSX.Element} The rendered component.
 */
function App({ premium, viewer, isAnon }) {
  const steps = [
    {
      selector: '#fretboard-settings-button',
      content: 'Customize your fretboard\'s look with the fretboard settings menu. Adjust these settings first to ensure they apply to all your diagrams seamlessly.',
    },
    {
      selector: '#tuning-control-button',
      content: 'Fine-tune each string with our Tuning Control, making it easy to adapt to alternate tunings or explore new sounds.',
    },
    {
      selector: '#code-editor-button',
      content: 'For those who prefer coding, our Code Editor lets you quickly input commands to create fretboard diagrams—ideal for a hands-on, efficient design process.',
    },
    {
      selector: '#fretboard-canvas',
      content: 'This is your playground: the Fretboard Diagram Interface. Add or remove notes with a click, customize your diagram, and then download it for your projects.  You can right click on the image and save it',
    },
    {
      selector: '#note-symbol',
      content: 'With the Note Tool, enrich your diagrams by adding symbols like mutes, root notes, finger numberings, to help create a detailed musical expression.',
    },
    {
      selector: '#colorscheme-select-symbol',
      content: 'Choose your vibe with the Color Scheme Selector. Customize colors for each note to make your fretboard diagrams visually striking and consistent.',
    },
    {
      selector: '#border-color-picker',
      content: 'Easily change the border color of your diagrams with the Border Color Selector, adding a personalized touch.',
    },
    {
      selector: '#fill-color-picker',
      content: 'The Fill Color Selector lets you dynamically choose fill colors, personalizing each diagram with a splash of color.',
    },
    {
      selector: '#text-color-picker',
      content: 'Adjust text colors within your diagrams using the Text Color Selector, ensuring readability and style.',
    },
    {
      selector: '#description-button',
      content: 'Add custom text below your diagrams with the Description Button. Perfect for annotations, chord names, or any info that enhances understanding.',
    },
    {
      selector: '#button-clear',
      content: 'Clear your diagram with the Clear Diagram Button. Start fresh or make quick adjustments to your fretboard.',
    },
    {
      selector: '#add-diagram-button',
      content: 'Expand your collection with the Add Diagram Button. Create animated sequences or variations of diagrams to vividly showcase musical concepts.',
    },
    {
      selector: '#drawings-container',
      content: 'Manage your fretboards in the Drawings Container. Animate, arrange, and showcase your diagrams, creating a visual symphony of your musical ideas.',
    },
    {
      selector: '#edit-field-description-wrapper',
      content: 'Use the Annotations Section to add notes or comments to your project, providing valuable insights or instructions alongside your diagrams.',
    },
    {
      selector: '#edit-submit',
      content: 'Secure your creations with the Save Button. Store your projects for easy access, sharing, or further editing, keeping your work organized and accessible.',
    },
  ];

  return (

    <TourProvider steps={steps}>
      <Fretboard
        textArea="edit-field-code-0-value"
        diagramsArea="edit-field-diagrams-0-value"
        descriptionArea="edit-field-diagram-descriptions-0-value"
        fretboardSettingsArea="edit-field-fretboard-settings-0-value"
        premium={premium}
        viewer={viewer}
        isAnon={isAnon}
      />
    </TourProvider>

  )

}

export default App
